
import { Vue, Component, VModel } from 'vue-property-decorator'

@Component({
    inheritAttrs: false,
})
export default class CostFilter extends Vue {
    @VModel() cost!: Record<string, any>
}
